export const ExcludedEmails = [
  "shahrozt20@gmail.com", // Sherry
  "mshehrozsajjad@gmail.com", // Sherry
  "lucasjacobson3@gmail.com", // Lucas
  "engr.awaisshafique@gmail.com", // Awais
  "awais.shafique03@gmail.com", // Awais
  "anna.tyrkich@gmail.com", // Anna
  "annaworkingaddress@gmail.com", // Anna
  "april.bachhuber@gmail.com", // April
  "aprilbachhuberwork@gmail.com", // April
  "user1@mailinator.com", // account used for testing
  "renefilip@mail.com", // René
  "egeyaygin@hotmail.com", // Ege
  "egeyaygin5@gmail.com", // Ege
]

export const ExcludedDomains = [
  "fa9r.com",
  "beyondpresence.ai",
  "mailinator.com",
]
